var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z",
    fill: "#2B7FD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13V3H8.4931C9.62064 3 10.4859 3.27701 11.0888 3.83104C11.6963 4.38507 12 5.14057 12 6.09753C12 7.05449 11.6963 7.81456 11.0888 8.37775C10.4859 8.94093 9.62064 9.22253 8.4931 9.22253H6.58777V13H5ZM6.58777 7.97253H8.43097C9.16732 7.97253 9.68047 7.79625 9.97041 7.44368C10.265 7.08654 10.4122 6.63782 10.4122 6.09753C10.4122 5.55723 10.265 5.11538 9.97041 4.77198C9.68047 4.42399 9.16732 4.25 8.43097 4.25H6.58777V7.97253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.fc4fcb7181f95d2bf48f7c65ea8aa589.svg";
export { ForwardRef as ReactComponent };